class DataCountup {
  constructor(rootSelector) {
    this.root = document.querySelector(rootSelector);

    if (!this.root) {
      return;
    }

    this.targets = Array.from(this.root.querySelectorAll('.js-countup'));
    if (!this.targets.length) {
      return;
    }

    this.isStarted = false;
    this.handleIntersect = this.handleIntersect.bind(this);

    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(this.handleIntersect, {
        root: null,
        threshold: 0.25,
      });
      this.observer.observe(this.root);
    } else {
      this.start();
    }
  }

  handleIntersect(entries) {
    if (this.isStarted) {
      return;
    }

    const isVisible = entries.some((entry) => entry.isIntersecting);
    if (!isVisible) {
      return;
    }

    this.start();
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  start() {
    if (this.isStarted) {
      return;
    }

    this.isStarted = true;
    this.targets.forEach((target) => this.animateTarget(target));
  }

  animateTarget(target) {
    const rawCountTo = target.dataset.countTo;
    const countTo = Number(rawCountTo);
    if (Number.isNaN(countTo)) {
      return;
    }

    const decimalsFromData = Number(target.dataset.countDecimals);
    const decimals = Number.isInteger(decimalsFromData)
      ? decimalsFromData
      : this.detectDecimals(rawCountTo);
    const hasDecimal = decimals > 0;
    const hasComma = target.classList.contains('p-top__data-value-number--has-comma');
    const duration = 1500;
    const startTime = performance.now();

    const update = (now) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easedProgress = 1 - (1 - progress) ** 3;
      const value = countTo * easedProgress;
      const displayValue = progress === 1 ? countTo : value;

      this.renderValue(target, displayValue, {
        decimals,
        hasDecimal,
        hasComma,
      });

      if (progress < 1) {
        requestAnimationFrame(update);
      }
    };

    requestAnimationFrame(update);
  }

  detectDecimals(rawValue) {
    if (typeof rawValue !== 'string') {
      return 0;
    }

    const dotIndex = rawValue.indexOf('.');
    if (dotIndex === -1) {
      return 0;
    }

    return rawValue.slice(dotIndex + 1).length;
  }

  renderValue(target, value, { decimals, hasDecimal, hasComma }) {
    const fixedValue = value.toFixed(decimals);
    const [integerPartRaw, decimalPartRaw = ''] = fixedValue.split('.');
    const integerPart = hasComma
      ? Number(integerPartRaw).toLocaleString('ja-JP')
      : integerPartRaw;

    if (hasDecimal) {
      const integerNode = document.createElement('span');
      integerNode.className = 'p-top__data-value-number-integer';
      integerNode.textContent = integerPart;

      const decimalNode = document.createElement('span');
      decimalNode.className = 'p-top__data-value-number-decimal';
      decimalNode.textContent = `.${decimalPartRaw}`;

      target.replaceChildren(integerNode, decimalNode);
      return;
    }

    target.textContent = integerPart;
  }
}
